<template>
    <v-layout row class="offset-2">
      <v-dialog v-model="error" width="500">
        <v-card>
          <v-card-title class="headline red accent-3" primary-title>
            Warning Message
          </v-card-title>
  
          <v-card-text>
            {{ errorMsg }}
          </v-card-text>
  
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red accent-3" flat @click="error = 0">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <v-snackbar
          v-model="snackbar"
          :right="x === 'right'"
          :timeout="timeout"
          :color="color"
          :top="y === 'top'"
        >
          {{ msg }}
          <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </div>
      <v-layout xs12 class="offset-2">
        <v-container grid-list-md>
          <v-flex xs12 class="ml-2">
            <v-card-title class="white darken-1 text-xs-center">
              <span class="headline mx-auto black--text">Delete User Request</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <!-- <v-layout wrap> -->
                
                <v-layout row>
                  <v-flex xs12 class="mr-2">
                    <v-text-field
                      v-model="phone"
                      :rules="[(v) => !!v || 'Phone is required']"
                      label="Phone*"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row v-if="otp_sent">
                  <v-flex xs12 class="mr-2">
                    <v-text-field
                      v-model="otp"
                      :rules="[(v) => !!v || 'OTP is required']"
                      label="OTP*"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row v-if="otp_sent">
                  <v-flex xs12 class="ml-2">
                    <v-textarea
                      v-model="reason"
                      :rules="[(v) => !!v || 'Reason is required']"
                      label="Reason*"
                      required
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <!-- </v-layout> -->
                <!-- </v-container> -->
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              
              <v-btn v-if="otp == '' && phone != ''"
                color="red darken-1"
                class="btn-large white--text"
                @click="sendOtp"
                >Request OTP</v-btn
              >
              <v-btn v-if="otp"
                color="red darken-1"
                class="btn-large white--text"
                @click="storeOrUpdate"
                >Request Delete</v-btn
              >
            </v-card-actions>
          </v-flex>
        </v-container>
      </v-layout>
    </v-layout>
  </template>
  
  <script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  
  export default {
    data: () => ({
      error: 0,
      errorMsg: "",
      valid: true,
      snackbar: false,
      color: "success",
      msg: "Submitted successfully",
      y: "top",
      x: "right",
      timeout: 3000,
      dialog: false,
      otp_sent:false,
      phone: '',
      otp: '',
      reason: '',
    }),
  
    computed: {
      ...mapState(["auth"]),
    },
    async mounted() {
      // await this.getDivDistUpz();
    },
  
    created() {
      // this.initialize();
    },
  
    methods: {
      async storeOrUpdate() {
        this.loading = true;
        try {
          const { data } = await api.storeData(this.auth.token, "dasher-delete-request", {
            phone: this.phone,
            otp: this.otp,
            reason: this.reason,
          });
  
          if (data.error) {
            this.color = "error";
            this.msg = data.errorMsg;
          } else {
            this.color = "success";
            this.msg = "User Delete request submitted successfully";
            this.$refs.form.reset();
          }
  
          this.snackbar = true;
          this.loading = false;
          this.close();
        } catch (e) {
          // console.log(e);
        }
      },
  
      async sendOtp() {
        this.loading = true;
        try {
          const { data } = await api.storeData(this.auth.token, "dasher-delete-request-otp", {
            phone: this.phone,
          });
  
          if (data.error) {
            this.color = "error";
            this.msg = data.errorMsg;
          } else {
            this.otp_sent = true;
            this.color = "success";
            this.msg = "OTP Send";
            // this.$refs.form.reset();
          }
  
          this.snackbar = true;
          this.loading = false;
          this.close();
        } catch (e) {
          // console.log(e);
        }
      },
  
      close() {
        this.dialog = false;
        setTimeout(() => {}, 300);
      },
    },
  };
  </script>
  